export const RENEW_PAGE_ADJUST_CAR_VALUE = 'RENEW_PAGE_ADJUST_CAR_VALUE'
export const RENEW_PAGE_CHOOSE_DOWNGRADE_PLAN = 'RENEW_PAGE_CHOOSE_DOWNGRADE_PLAN'
export const RENEW_PAGE_CPR_NUMBER = 'RENEW_PAGE_CPR_NUMBER'
export const RENEW_PAGE_CPR_PLATE_NUMBER = 'RENEW_PAGE_CPR_PLATE_NUMBER'
export const RENEW_PAGE_ENHANCE_YOUR_COVERAGE = 'RENEW_PAGE_ENHANCE_YOUR_COVERAGE'
export const RENEW_PAGE_REVIEW_AND_CONFIRM = 'RENEW_PAGE_REVIEW_AND_CONFIRM'
export const RENEW_PAGE_REVIEW_YOUR_POLICY = 'RENEW_PAGE_REVIEW_YOUR_POLICY'
export const RENEW_PAGE_SELECT_POLICY = 'RENEW_PAGE_SELECT_POLICY'
export const RENEW_PAGE_VERIFY_OTP = 'RENEW_PAGE_VERIFY_OTP'
export const RENEW_PAGE_LOGIN_OTP = 'RENEW_PAGE_LOGIN_OTP'
export const RENEW_PAGE_UPLOAD_PHOTOS = 'RENEW_PAGE_UPLOAD_PHOTOS'
export const CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR=`CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR`
